import React from 'react';
import styled from 'styled-components';
import { setInformacao } from '@ducks/conectoresConfiguracoesInformacoes';
import { useSelector, useDispatch } from 'react-redux';
import { Icon, View, Table, TableColumnOpcoes } from '@components';
import { useHistory, useParams } from 'react-router-dom';

const ColumnInformacao = styled(View)`
  font-size: 20px;
  flex-direction: row;
`;

const ColumnOpcoes = styled(TableColumnOpcoes)`
  font-size: 20px;
`;

export default function TableInformacoes({ dataSource }) {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const informacao = useSelector(({ conectoresConfiguracoesInformacoes }) => conectoresConfiguracoesInformacoes.get('informacao'));

  const handleSelect = (item) => {
    localStorage.setItem('ultimoTipoInformacaoConfiguracao', item.tipo);
    dispatch(setInformacao(item));
  };

  const columns = [
    {
      title: 'Informação',
      key: 'informacao',
      render: (text, item) => <ColumnInformacao>{item.informacao}</ColumnInformacao>,
    },
    {
      title: 'Opções',
      key: 'options',
      align: 'right',
      render: (text, item) => (
        <ColumnOpcoes>
          {item.addUrl ? (
            <Icon.Add
              action={() => {
                if (item.callBefore) {
                  item.callBefore();
                }
                history.push(item.addUrl.replace('@id', id));
                if (item.callAfter) {
                  setTimeout(item.callAfter, 500);
                }
              }}
            />
          ) : (
            <></>
          )}
          {item.tipo === informacao.tipo ? <Icon.Selected /> : <Icon.Detail action={() => handleSelect(item)} />}
        </ColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='informacao' columns={columns} dataSource={dataSource} hidePagination />;
}
